import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M3 18.5v-5q0-.444.256-.946.255-.502.744-.754V9.5q0-.846.577-1.423A1.93 1.93 0 0 1 6 7.5h4.5q.518 0 .883.213.365.212.617.587.252-.375.617-.588.366-.212.883-.212H18q.846 0 1.423.577T20 9.5v2.3q.489.252.744.754.256.502.256.946v5h-1v-2H4v2zm9.5-7H19v-2a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 8.5h-4.5a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713zm-7.5 0h6.5v-2a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287H6a.97.97 0 0 0-.713.287A.97.97 0 0 0 5 9.5zm-1 4h16v-2a.97.97 0 0 0-.288-.713A.97.97 0 0 0 19 12.5H5a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 13.5z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }